import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getAdminMerchantsUnassigned,
  type SortDirection,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const UNASSIGNED_MERCHANTS_QUERY_KEY = "UNASSIGNED_MERCHANTS";

export type UnassignedMerchantsParams = {
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortDirection?: SortDirection;
  statuses?: Array<string>;
  companyName?: string;
  companyNumber?: string;
  dateCreatedFrom?: string;
  dateCreatedTo?: string;
};

export const unassignedMerchantsKeys = {
  all: [UNASSIGNED_MERCHANTS_QUERY_KEY],
  byParams: (params: UnassignedMerchantsParams) => [
    ...unassignedMerchantsKeys.all,
    params,
  ],
};

export const useUnassignedMerchantsQuery = (
  params: UnassignedMerchantsParams = {},
) =>
  useQuery({
    queryKey: unassignedMerchantsKeys.byParams(params),
    queryFn: processResponseWithApiProblemDetails(() =>
      getAdminMerchantsUnassigned(
        params.statuses,
        params.companyName,
        params.companyNumber,
        params.dateCreatedFrom,
        params.dateCreatedTo,
        params.offset,
        params.limit,
        params.sortBy,
        params.sortDirection,
      ),
    ),
    placeholderData: keepPreviousData,
    staleTime: 2 * MS_TIME.minute,
  });
